const SAVED_DRAFT_EDIT_STORAGE_KEY = 'merchant_saved_draft_edit';
const SAVED_DRAFT_EDIT_MAX_AGE_MS = 30 * 60 * 1000;

const getSessionStorage = storage => {
    if (storage) {
        return storage;
    }

    return typeof window !== 'undefined' ? window.sessionStorage : null;
};

export const saveSavedDraftEditState = (draftState, storage, now = Date.now()) => {
    const shipment = draftState && draftState.shipment;

    if (!shipment || !shipment.shipment_id) {
        return false;
    }

    try {
        const targetStorage = getSessionStorage(storage);
        if (!targetStorage) {
            return false;
        }

        targetStorage.setItem(SAVED_DRAFT_EDIT_STORAGE_KEY, JSON.stringify({
            savedAt: now,
            draftState,
        }));
        return true;
    } catch (_) {
        return false;
    }
};

export const readSavedDraftEditState = (storage, now = Date.now()) => {
    try {
        const targetStorage = getSessionStorage(storage);
        const rawState = targetStorage ? targetStorage.getItem(SAVED_DRAFT_EDIT_STORAGE_KEY) : null;
        const parsedState = rawState ? JSON.parse(rawState) : null;
        const draftState = parsedState && parsedState.draftState;
        const shipment = draftState && draftState.shipment;
        const savedAt = Number(parsedState && parsedState.savedAt);

        if (!shipment || !shipment.shipment_id || !Number.isFinite(savedAt) || now - savedAt > SAVED_DRAFT_EDIT_MAX_AGE_MS) {
            if (targetStorage) {
                targetStorage.removeItem(SAVED_DRAFT_EDIT_STORAGE_KEY);
            }
            return null;
        }

        return draftState;
    } catch (_) {
        return null;
    }
};

export const clearSavedDraftEditState = storage => {
    try {
        const targetStorage = getSessionStorage(storage);
        if (targetStorage) {
            targetStorage.removeItem(SAVED_DRAFT_EDIT_STORAGE_KEY);
        }
    } catch (_) {}
};